import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/financeLoan',
    meta: { title: '金融贷款管理' },
    component: Layout,
    redirect: '/financeLoan/list',
    children: [
      {
        path: 'list',
        meta: { title: '金融贷款管理', activeMenu: '/financeLoan' },
        component: () => import('@/views/financeLoan/List.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增金融贷款',
          activeMenu: '/financeLoan'
        },
        component: () => import('@/views/financeLoan/Add.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑金融贷款',
          activeMenu: '/financeLoan'
        },
        component: () => import('@/views/financeLoan/Add.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '金融贷款详情',
          activeMenu: '/financeLoan'
        },
        component: () => import('@/views/financeLoan/Detail.vue')
      }

    ]
  }
]
